import { Box, BoxProps, Flex } from '@chakra-ui/react';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { ReactElement } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { markdownSx } from '../Common/styles';
import { Icon } from '../Icon/Icon';

const iconSx = {
  color: 'green.800',
  fontSize: '1.1em',
  py: 1,
  mr: 3,
};

const Markdown = ({
  children,
  sx,
  ...rest
}: Omit<BoxProps, 'children'> & {
  children: string;
}): ReactElement | null => (
  <Box sx={{ ...markdownSx, ...sx }} {...rest}>
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      rehypePlugins={[rehypeRaw] as any}
      components={{
        li: ({ className, children }) =>
          className === 'task-list-item' ? (
            <Flex w="full" as="li" mb={2} listStyleType="none">
              <Icon icon={faCheck} className={className} sx={iconSx} />
              <div>{children}</div>
            </Flex>
          ) : (
            <li className={className}>{children}</li>
          ),
        a: ({ className, href, children }) => (
          <a className={className} href={href} rel="noreferrer" target="_blank">
            {children}
          </a>
        ),
        input: () => null,
      }}
    >
      {children}
    </ReactMarkdown>
  </Box>
);

export default Markdown;
